export default "__VITE_ASSET__6c2bf1f0__"